import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Typography, Toolbar, Card } from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';


const useStyles = makeStyles({
  table: {
    // minWidth: 650,
  },

  trRow:{
    '& td':{
      padding: 6
    }
  } ,
  cardDiv:{
    display: 'flex',
    flex: 1,
    height: '100%',
    overflowX: 'hidden',
    flexDirection: 'column',
    justifyContent: 'center'
} 
});

const orders = [{
  orderId: '#9101',
  invoice: 'INV-001001',
  customer: 'William Joy',
  email: 'William@example.com',
  profit: '$120',
  status: 'pending',
},
{
  orderId: '#9102',
  invoice: 'INV-001002',
  customer: 'Thomas Arin',
  email: 'Thomas@example.com',
  profit: '$210',
  status: 'pending',
},
{
  orderId: '#9103',
  invoice: 'INV-001003',
  customer: 'James Smith',
  email: 'James@example.com',
  profit: '$452.50',
  status: 'pending',
},
{
  orderId: '#9104',
  invoice: 'INV-001004',
  customer: 'James Johnson',
  email: 'Johnson@example.com',
  profit: '$400',
  status: 'pending',
},
{
  orderId: '#9105',
  invoice: 'INV-001005',
  customer: 'Maria Hernandez',
  email: 'Hernandez@example.com',
  profit: '$506.50',
  status: 'pending',
}
]

export default function RecentOrders() {
  const classes = useStyles();

  return (
    <Card className={classes.cardDiv}>
     
      <Toolbar>
        <Typography variant="h6" >
          Recent Orders List
      </Typography>
      </Toolbar>
      <TableContainer >
      <PerfectScrollbar>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>orderId</TableCell>
              <TableCell >invoice</TableCell>
              <TableCell >customer</TableCell>
              <TableCell >profit</TableCell>
              <TableCell align="center">status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody >
            {orders.map((row) => (
              <TableRow key={row.orderId} className={classes.trRow}
                hover
              >
                <TableCell component="th" scope="row">
                  {row.orderId}
                </TableCell>
                <TableCell >{row.invoice}</TableCell>
                <TableCell >
                  {row.customer}
                  <p>{row.email}</p>
                </TableCell>
                <TableCell >{row.profit}</TableCell>
                <TableCell align="center">{row.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </PerfectScrollbar>
      </TableContainer>
     
    </Card>
  ); 
}